<template>
  <div>
    <Person :data="data.addressee" v-if="data.addressee.person" />

    <Organization :data="data.addressee" v-if="data.addressee.organization" />

    <ForeignOrganization
      :data="data.addressee"
      v-if="data.addressee.foreignOrganization"
    />
  </div>
</template>

<script>
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';
import { createDataField } from '@/utils/fullStatementView';

export default {
  name: 'Step2',
  components: {
    Person,
    Organization,
    ForeignOrganization,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
  methods: {},
};
</script>
